import gql from 'graphql-tag';

const externalOnboardingQueueRecordQuery = gql`
  query ExternalOnboardingQueueRecord($flatRateOfferId: String!) {
    externalOnboardingQueueRecord(flatRateOfferId: $flatRateOfferId) {
      flatRateOfferId
      flatRateOfferBatchId
      customerId
      status
      reason
      productType
      offerAcceptedDate
      dealerName
      dealerEmail
      dealerPhone
      createdAt
      completedAt
      updatedAt
      updatedBy
      noteCount
      subscriptionPrice
      notes {
        id
        note
        createdBy
        createdAt
      }
    }
  }
`;

export default externalOnboardingQueueRecordQuery;
